import * as React from "react"

import * as styles from "./styles.module.scss"

import { FlowVocabularyData, FlowDictionaryTermTriggers } from "types"
import DictionaryTerm from "../DictionaryTerm"

export type DictionaryProps = {
  userAnswers: any
  vocabulary: FlowVocabularyData
}

const Dictionary: React.FC<DictionaryProps> = ({ vocabulary, userAnswers }) => {
  const matchTrigger = ({ id, values }: FlowDictionaryTermTriggers) =>
    values.some((v) => v === userAnswers[id]?.value)

  const shouldShowTerm = (key: string) =>
    vocabulary[key].triggers.some((trigger) => matchTrigger(trigger))

  return (
    <section className={styles.dictionary}>
      <div className={styles.pagePadding}>
        <div className={styles.header}>
          <h2 className={styles.heading}>Don’t let the jargon get you down</h2>
          <p className={styles.subhead}>
            You’ll see words like these when refinancing
          </p>
        </div>
        <ul className={styles.list}>
          {Object.keys(vocabulary).map((key) =>
            shouldShowTerm(key) ? (
              <DictionaryTerm key={key} term={vocabulary[key]} />
            ) : null
          )}
        </ul>
      </div>
    </section>
  )
}

export default Dictionary
